<template>
  <div id="userDetails">
    <headTopTwo :title="title" :getleft="showArrow" :showUser="showUser" />

    <el-row class="mt20">
      <el-col :span="4"></el-col>
      <el-col :span="16" class="system">
        <div class="left">
          <div class="left-top">
            <div class="left-top-icon">
              <span class="el-icon-s-custom"></span>
            </div>
            <span class="left-top-name">{{ userName }}</span>
          </div>
          <div class="left-bottom">
            <p @click="clickUserInfo">
              <span :class="showUserInfo ? 'active' : ''">基本信息</span>
            </p>
            <p @click="clickSonSystem">
              <span :class="!showUserInfo ? 'active' : ''">子系统权限</span>
            </p>
          </div>
        </div>
        <div class="right" v-if="showUserInfo">
          <div id="userInfo">
            <el-card class="userInfo-card">
              <div class="userInfo-page-cont">
                <div class="userInfo-page-title">
                  <span>基本信息</span>
                </div>
                <el-form
                  ref="formRef"
                  :rules="rules"
                  :model="formData"
                  label-width="95px"
                  class="userInfo-form-style"
                >
                  <el-row>
                    <el-col :span="11" class="mr30">
                      <el-form-item
                        label="姓名"
                        class="require-item"
                        label-width="110px"
                        prop="name"
                      >
                        <el-input
                          v-model="formData.name"
                          clearable
                          placeholder="请输入"
                        ></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="11">
                      <el-form-item
                        label="手机号"
                        class="require-item"
                        label-width="110px"
                        prop="tel"
                      >
                        <el-input
                          v-model="formData.tel"
                          clearable
                          placeholder="请输入"
                        ></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row class="mt20">
                    <el-col :span="11" class="mr30">
                      <el-form-item
                        label="用户名"
                        class="require-item"
                        label-width="110px"
                        prop="userName"
                      >
                        <el-input
                          autocomplete="off"
                          v-model="formData.userName"
                          clearable
                          placeholder="请输入"
                        ></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="11">
                      <el-form-item
                        label="密码"
                        class="require-item"
                        label-width="110px"
                        prop="password"
                      >
                        <el-input
                          autocomplete="new-password"
                          clearable
                          placeholder="请输入"
                          v-model="formData.password"
                          show-password
                        ></el-input>
                        <div v-show="showPassTip" class="pass-tip">
                          密码组合为数字+字母+特殊字符，长度大于等于8位且小于等于12位
                        </div>
                      </el-form-item>
                    </el-col>
                  </el-row>

                  <el-row class="mt20">
                    <el-col :span="11" class="mr30">
                      <el-form-item
                        label="微信号"
                        style="margin-left: 13px"
                        label-width="97px"
                        prop="wx"
                      >
                        <el-input
                          v-model="formData.wx"
                          placeholder="请输入"
                          clearable
                        ></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="11">
                      <el-form-item
                        label="邮箱"
                        style="margin-left: 13px"
                        label-width="97px"
                        prop="email"
                      >
                        <el-input
                          v-model="formData.email"
                          clearable
                          placeholder="请输入"
                        ></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>

                  <el-row class="mt20">
                    <el-col :span="11" class="mr30">
                      <el-form-item
                        label="性别"
                        class="require-item select-width"
                        label-width="110px"
                      >
                        <el-select v-model="formData.sex">
                          <el-option
                            v-for="item in sexList"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                          >
                          </el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                    <el-col :span="11">
                      <el-form-item
                        label="用户状态"
                        class="require-item select-width"
                        label-width="110px"
                      >
                        <el-select v-model="formData.status">
                          <el-option
                            v-for="item in statusList"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                          >
                          </el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                  </el-row>

                  <el-row class="mt20">
                    <el-col :span="11" class="mr30">
                      <el-form-item
                        label="组织机构"
                        class="user-org-label"
                        style="margin-left: 13px"
                        label-width="97px"
                      >
                        <span
                          class="el-icon-edit-outline userInfo-edit-icon"
                        ></span>
                        <el-popover
                          placement="bottom"
                          class="h384"
                          trigger="click"
                        >
                          <el-tree
                            ref="tree1"
                            :data="orgList"
                            show-checkbox
                            node-key="organizeId"
                            :check-strictly="true"
                            :props="prop1"
                            @check="checkOrg"
                          >
                          </el-tree>
                          <el-input
                            slot="reference"
                            style="cursor: pointer"
                            type="text"
                            readonly
                            v-model="formData.orgNameList"
                          >
                            <!-- type="textarea"
                            :rows="3"
                            resize="none" -->
                          </el-input>
                        </el-popover>
                      </el-form-item>
                    </el-col>
                    <el-col :span="11">
                      <el-form-item
                        label="是否主账号"
                        class="require-item"
                        label-width="110px"
                      >
                        <el-radio-group
                          v-model="formData.account"
                          @change="changeAccount"
                        >
                          <el-radio :label="1">是</el-radio>
                          <el-radio :label="2">否</el-radio>
                        </el-radio-group>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-form>
                <div class="userInfo-page-title" style="margin-top: 20px">
                  <span>菜单权限</span>
                </div>
                <div class="userInfo-menu-cont" v-show="formData.account == 1">
                  <el-tree
                    ref="menu1"
                    style="margin: 30px 30px 0"
                    :data="menuData"
                    show-checkbox
                    node-key="menuId"
                    :check-strictly="true"
                    :props="prop2"
                    @check-change="checkChange"
                    @check="checkMenu"
                  >
                  </el-tree>
                </div>
                <!-- @check="checkMenu"   @check="checkMenu" -->
                <div class="menu-content" v-show="formData.account == 2">
                  <el-tree
                    ref="menu2"
                    style="margin: 20px 10px 0 10%"
                    :data="sonMenuData"
                    show-checkbox
                    node-key="menuId"
                    :check-strictly="true"
                    :props="prop2"
                    @check-change="checkChange"
                    @check="checkMenu"
                  >
                  </el-tree>
                </div>
                <div class="save-btn">
                  <el-button
                    type="primary"
                    style="height: 48px"
                    @click="submitEditUser('formRef')"
                    >保存</el-button
                  >
                </div>
              </div>
            </el-card>
          </div>
        </div>
        <div class="right" v-if="!showUserInfo">
          <sonSystem />
        </div>
      </el-col>
      <el-col :span="4">&nbsp;</el-col>
    </el-row>
  </div>
</template>

<script>
import headTopTwo from "../../components/headTopTwo.vue";
import sonSystem from "../../components/sonSystem.vue";
import navLeft from "../../components/navLeft.vue";
export default {
  data() {
    var validatePass = (rule, value, callback) => {
      var passReg =
        /^(?=.*[A-Za-z])(?=.*\d)(?=.*[$@$!%*_.,。，/|#?&])[A-Za-z\d$@$!%*_.,。，/|#?&]{8,12}$/g;
      // if (value === "") {
      //   callback(new Error("请输入密码"));
      // } else
      if (!passReg.test(value)) {
        this.showPassTip = false;
        callback(
          new Error(
            "密码组合为数字+字母+特殊字符，长度大于等于8位且小于等于12位"
          )
        );
      } else {
        this.showPassTip = true;
        callback();
      }
    };
    var validateTel = (rule, value, callback) => {
      var telReg = /^1[3456789]\d{9}$/g;
      if (value === "") {
        callback(new Error("请输入手机号"));
      } else if (!telReg.test(value)) {
        callback(new Error("请输入正确的手机号"));
      } else {
        callback();
      }
    };
    var validateWx = (rule, value, callback) => {
      var wxReg = /^[a-zA-Z][a-zA-Z\d_-]{5,19}$/g;
      if (value != "" && !wxReg.test(value)) {
        callback(new Error("请输入正确的微信号"));
      } else {
        callback();
      }
    };
    var validateEmail = (rule, value, callback) => {
      var wxReg = /^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/g;
      if (value != "" && !wxReg.test(value)) {
        callback(new Error("请输入正确的邮箱号"));
      } else {
        callback();
      }
    };
    return {
      showArrow: true,
      showUserInfo: true,
      userId: "",
      userName: "",
      showUser: true,
      title: "用户详情",

      formData: {
        name: "",
        userName: "",
        password: "",
        orgLinkCodeList: [],
        orgNameList: "",
        tel: "",
        sex: 1,
        wx: "",
        email: "",
        account: 1,
        status: 0,
        menuSelected: [],
        menuSelectedList: [],
      },
      sexList: [
        {
          value: 1,
          label: "男",
        },
        {
          value: 2,
          label: "女",
        },
      ],
      statusList: [
        {
          value: 0,
          label: "正常",
        },
        {
          value: 1,
          label: "删除",
        },
      ],
      menuData: [],
      prop1: {
        children: "childs",
        label: "name",
      },
      prop2: {
        children: "childs",
        label: "menuName",
        disabled: "disabled",
      },
      dialogVisible1: false,
      orgList: [],
      checkedOrg: [],
      availableList: [],
      rules: {
        name: [{ required: true, message: "请输入姓名", trigger: "blur" }],
        tel: [{ validator: validateTel, trigger: "blur" }],
        userName: [
          { required: true, message: "请输入用户名", trigger: "blur" },
        ],
        password: [{ validator: validatePass, trigger: "blur" }],
        wx: [{ validator: validateWx, trigger: "blur" }],
        email: [{ validator: validateEmail, trigger: "blur" }],
      },
      sonMenuData: [],
      showPassTip: true,
    };
  },
  mounted() {
    this.userId = this.$route.params && this.$route.params.userId;
    this.userName = this.$route.params && this.$route.params.userName;
    this.getDataList();
  },
  beforeDestroy() {
    window.localStorage.setItem("userId", "");
  },
  components: {
    headTopTwo,
    sonSystem,
    navLeft,
  },
  methods: {
    checkChange(data, isBoolean) {
      if (data.position == 2 && isBoolean) {
        this.$refs.menu1.setChecked("127657991278", true, false);
      }
      if (data.menuId == "127657991278" && !isBoolean) {
        let arr = this.$refs.menu1.getCheckedNodes();
        arr.forEach((item) => {
          if (item.position == 2) {
            this.$refs.menu1.setChecked(item.menuId, false, false);
          }
        });
      }
      //用户管理
    },
    clickUserInfo() {
      this.showUserInfo = true;
      this.getDataList();
    },
    clickSonSystem() {
      this.showUserInfo = false;
    },

    getDataList() {
      let self = this;
      let params = new FormData();
      params.append("userId", self.userId);
      localStorage.setItem("gouserId", self.userId);
      self.$http.post(
        self.api.selecDetailsByUserId,
        params,
        {},
        (res) => {
          if (res.code == 200) {
            if (res.body != "null") {
              let data = res.body;
              self.formData = {
                name: data.nickName,
                userName: data.account,
                password: data.password,
                orgLinkCodeList: data.organizeIds,
                tel: data.phoneNumber,
                sex: data.sex,
                wx: data.wechat,
                email: data.email,
                account: data.mainFlag ? 1 : 2,
                status: data.status,
                menuSelected: data.menuIds,
              };
              if (data.orgString && data.orgString != "null") {
                let result = "";
                data.orgString.forEach((item) => {
                  result += item + ",";
                });
                self.formData.orgNameList = result;
              }
              self.getOrgList();
              self.getHasMenus();
            }
          }
        },
        (error) => {}
      );
    },

    getOrgList() {
      let self = this;
      let params = new FormData();
      self.$http.post(
        self.api.allOrganizationJSON,
        params,
        {},
        (res) => {
          if (res.code == 200) {
            if (res.body != "null") {
              self.orgList = res.body;
              if (self.formData.orgLinkCodeList) {
                self.$refs.tree1.setCheckedKeys(
                  self.formData.orgLinkCodeList,
                  true,
                  false
                );
              }
            }
          }
        },
        (error) => {}
      );
    },

    getHasMenus() {
      let self = this;
      let params = new FormData();
      self.$http.post(
        self.api.selfHasMenus,
        params,
        {},
        (res) => {
          if (res.code == 200) {
            if (res.body != "null") {
              self.availableList = res.body;
              self.getMenuList();
              self.getSonMenuList();
            }
          }
        },
        (error) => {}
      );
    },

    getMenuList() {
      let self = this;
      let params = new FormData();
      self.$http.post(
        self.api.allMenu,
        params,
        {},
        (res) => {
          if (res.code == 200) {
            if (res.body != "null") {
              let list = self.availableList;
              if (list && res.body) {
                tree(res.body);
                function tree(value) {
                  value.forEach((item) => {
                    let flag1 = true;
                    list.forEach((itemson) => {
                      if (item.menuId == itemson.menuId) {
                        flag1 = false;
                      }
                    });
                    if (flag1) {
                      item.disabled = "disabled";
                    }
                    if (item.childs && item.childs.length > 0) {
                      tree(item.childs);
                    }
                  });
                }
              }
              self.menuData = res.body;
              self.$refs.menu1.setCheckedKeys(
                self.formData.menuSelected,
                true,
                false
              );
            }
          }
        },
        (error) => {}
      );
    },

    getSonMenuList() {
      let self = this;
      let params = new FormData();
      self.$http.post(
        self.api.allMenu,
        params,
        {},
        (res) => {
          if (res.code == 200) {
            if (res.body != "null") {
              let list = self.availableList;
              if (list && res.body) {
                tree(res.body);
                function tree(value) {
                  value.forEach((item) => {
                    let flag2 = true;
                    list.forEach((itemson) => {
                      if (
                        item.menuId == itemson.menuId &&
                        itemson.position == 0
                      ) {
                        flag2 = false;
                      }
                    });
                    if (flag2) {
                      item.disabled = "disabled";
                    }
                    if (item.childs && item.childs.length > 0) {
                      tree(item.childs);
                    }
                  });
                }
              }
              self.sonMenuData = res.body;
              self.$refs.menu2.setCheckedKeys(
                self.formData.menuSelected,
                true,
                false
              );
            }
          }
        },
        (error) => {}
      );
    },

    changeAccount(value) {
      this.formData.menuSelected = [];
      this.formData.menuSelectedList = [];
      this.$refs.menu1.setCheckedKeys([], false, false);
      this.$refs.menu2.setCheckedKeys([], false, false);
    },

     checkChange(data, isBoolean) {
      if (data.position == 2 && isBoolean) {
        this.$refs.menu1.setChecked("127657991278", true, false);
      }
      if (data.menuId == "127657991278" && !isBoolean) {
        let arr = this.$refs.menu1.getCheckedNodes();
        arr.forEach((item) => {
          if (item.position == 2) {
            this.$refs.menu1.setChecked(item.menuId, false, false);
          }
        });
      }
    },

    checkMenu(data, node) {
      this.formData.menuSelected = node.checkedKeys;
      this.formData.menuSelectedList = node.checkedNodes;
    },

    checkOrg(data, node) {
      let result = "";
      if (node.checkedNodes) {
        node.checkedNodes.forEach((item) => {
          result += item.name + ",";
        });
      }
      this.formData.orgNameList = result;
      this.formData.orgLinkCodeList = node.checkedKeys;
      this.$forceUpdate();
    },

    submitEditUser(formRef) {
      let self = this;
      self.$refs[formRef].validate((valid) => {
        if (valid) {
          if (self.formData.menuSelectedList) {
            self.formData.menuSelectedList.forEach((item) => {
              if (item.position == 2) {
                self.formData.menuSelected.push(127657991278);
                return;
              }
            });
            self.$refs.menu1.setCheckedKeys(
              self.formData.menuSelected,
              true,
              false
            );
          }
          let params = {
            userId: self.userId,
            nickName: self.formData.name, // 姓名
            account: self.formData.userName, // 用户名
            password: self.formData.password,
            email: self.formData.email,
            phoneNumber: self.formData.tel,
            sex: self.formData.sex,
            identityCard: "", // 身份证号
            photo: "", // 照片
            wechat: self.formData.wx,
            address: "", // 地址
            status: self.formData.status, // 用户状态
            mainFlag: Number(self.formData.account) == 1 ? true : false,
            organizeIds: self.formData.orgLinkCodeList,
            orgString: [],
            menuIds: self.formData.menuSelected,
          };
          self.$http.post(
            self.api.updateUser,
            params,
            {},
            (res) => {
              if (res.code == 200) {
                self.$message.success("修改用户成功！");
                self.$router.push("/authFront/userManage");
              } else {
                self.$message.warning(res.msg || "修改用户失败！");
              }
            },
            (error) => {}
          );
        } else {
          self.$message.warning("请检查输入正确后再提交");
        }
      });
    },
  },
};
</script>

<style>
.mt20 {
  margin-top: 20px;
}
.left {
  width: 25%;
}
.left .left-top {
  height: 80px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #fff;
}
.left .left-top .left-top-icon {
  display: inline-block;
  width: 38px;
  height: 38px;
  line-height: 38px;
  border-radius: 50%;
  background-color: #6ea5ff;
  text-align: center;
  margin-right: 18px;
}
.left .left-top .left-top-name {
  font-size: 20px;
  font-weight: 600;
  color: #333;
}
.left .left-top .left-top-icon span {
  font-size: 24px;
  color: #fff;
}
.left .left-bottom {
  height: 831px;
  background-color: #fff;
  margin-top: 20px;
  text-align: center;
  padding: 0 28px;
}
.left .left-bottom p {
  height: 66px;
  line-height: 66px;
  cursor: pointer;
}
.left .left-bottom p span.active {
  color: #333;
}
.left .left-bottom p span {
  font-size: 20px;
  font-weight: 600;
  color: #a3a3a3;
}
.left .left-bottom p:last-child {
  border-top: 1px solid #e3e5e8;
  border-bottom: 1px solid #e3e5e8;
}
.right {
  width: 73%;
  margin-left: 20px;
  height: 100%;
  overflow-y: auto;
}
#userDetails .system {
  padding: 0 20px 0 0;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  position: fixed;
  left: 320px;
  bottom: 0;
  top: 84px;
  right: 0;
  height: 100%;
  display: flex;
}

.require-item .el-form-item__label::before {
  content: "*";
  color: #f56c6c;
  margin-right: 4px;
}
.userInfo-card {
  box-shadow: none;
}
.mr30 {
  margin-right: 30px;
}
.el-card.is-always-shadow {
  box-shadow: none;
  border-radius: 0;
}
.userInfo-page-cont {
  width: 100%;
  margin: 0 auto;
  padding-bottom: 84px;
}
.userInfo-page-title {
  height: 44px;
  line-height: 44px;
  padding-left: 40px;
}
.userInfo-page-title span {
  font-size: 20px;
  font-weight: 600;
  color: #333;
}
.userInfo-page-title span::before {
  content: "";
  display: inline-block;
  width: 6px;
  height: 20px;
  background: #2878fc;
  border-radius: 3px;
  margin-right: 12px;
}
#userInfo .select-width .el-select {
  width: 100%;
}
.userInfo-form-style {
  width: 93%;
  padding-left: 48px;
  margin-top: 30px;
}
.userInfo-form-style .el-form-item__label {
  text-align: left;
}
.userInfo-form-style .el-form-item__label {
  font-size: 16px;
  font-weight: 600;
  color: #666666;
}
.userInfo-form-style .pass-tip {
  color: #8e8e8e;
  font-size: 12px;
  line-height: 16px;
  padding-top: 4px;
  position: absolute;
  top: 100%;
  left: 0;
  letter-spacing: 1px;
}
.el-form-item__error {
  line-height: 16px;
  letter-spacing: 1px;
}
.user-org-label {
  position: relative;
}
.userInfo-edit-icon {
  position: absolute;
  left: -96px;
  top: 34px;
  font-size: 16px;
  font-weight: 600;
}
.userInfo-menu-cont {
  width: 560px;
  height: 474px;
  overflow-y: auto;
  border-radius: 2px;
  border: 1px solid #e3e5e8;
  margin-left: 60px;
  margin-top: 15px;
}
.el-popover {
  width: 238px;
}
.h384 {
  height: 384px;
  overflow-y: auto;
}
#userInfo .save-btn {
  width: 300px;
  height: 48px;
  margin: 60px auto 0;
}
#userInfo .save-btn .el-button--primary {
  width: 100%;
  font-size: 16px;
}
.el-tree-node__label {
  font-size: 16px;
  font-weight: 600;
}
.el-tree__empty-text {
  line-height: 100px;
  text-align: center;
  color: #1890ff;
  font-size: 16px;
}
</style>


// WEBPACK FOOTER //
// src/view/userManage/details.vue